/**
 * Created by andrey on 07.05.2021.
 */

const WebViewSound = function (url) {
    this.url = url;
    this.startPlaying = 0;
};

WebViewSound.prototype.play = function () {
    this.startPlaying = Date.now();
};

WebViewSound.prototype.playing = function () {
    return this.startPlaying + WebViewSound.DURATION < Date.now();
};

WebViewSound.DURATION = 1000;